import { TERMS_AND_CONDITIONS_HTML } from "../customersMapper/customersMapper";

export const GLOBAL_ENDPOINTS = {
    TERMS_AND_CONDITIONS: (randomDigit) => TERMS_AND_CONDITIONS_HTML,
    GET_STATES: () => "/1/states",
};
